import React from 'react';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import * as d3 from 'd3';
import UriQuickSearch from './UriQuickSearch';
import { formatDisplayDate } from './commons';
import { useStaleness } from './useStaleness';
import LastCrawledChip from './LastCrawledChip';
import AgoChip from './AgoChip';

function formatWithTime(createDate, fallbackDateStr) {
    if (createDate) return d3.timeFormat('%d %b %Y · %H:%M')(new Date(createDate));
    return formatDisplayDate(fallbackDateStr);
}

export default function Header({ uri, isLoading }) {
    const { curSnapshotDate, lastSnapshotDate } = useSelector(s => s.currentMonitoredUri);
    const { isStale, createDate } = useStaleness();

    const isLatest = curSnapshotDate && curSnapshotDate === lastSnapshotDate;
    const isPast   = curSnapshotDate && lastSnapshotDate && curSnapshotDate !== lastSnapshotDate;
    const dateLabel = formatWithTime(createDate, curSnapshotDate);

    return (
        <Card $loading={isLoading}>
            <Meta>
                {isLatest && (isStale
                    ? <LastCrawledChip createDate={createDate} />
                    : <DateBadge $latest>Latest crawl · {dateLabel}</DateBadge>)}
                {isPast && <DateBadge>Snapshot · {dateLabel}</DateBadge>}
                {isPast && createDate && <AgoChip date={createDate} />}
            </Meta>
            <UriQuickSearch currentUri={uri} />
        </Card>
    );
}

const Card = styled.div`
    position: relative;
    background: #fff;
    border: 1px solid #e2e8f0;
    border-radius: 12px;
    padding: 20px 18px 22px;
    display: flex;
    flex-direction: column;
    gap: 8px;
    @media (max-width: 600px) { padding: 12px 14px; border-radius: 0; border-left: none; border-right: none; }
    &::after {
        content: '';
        display: ${({ $loading }) => $loading ? 'block' : 'none'};
        position: absolute;
        inset: 0;
        border-radius: 12px;
        background: rgba(255,255,255,0.6);
    }
`;

const Meta = styled.div`
    display: flex;
    align-items: center;
    gap: 16px;
`;

const DateBadge = styled.span`
    font-size: 0.68rem;
    font-weight: 600;
    padding: 2px 8px;
    border-radius: 20px;
    background: ${({ $latest }) => $latest ? '#eff6ff' : '#fffbeb'};
    color: ${({ $latest }) => $latest ? '#1d4ed8' : '#92400e'};
    border: 1px solid ${({ $latest }) => $latest ? '#bfdbfe' : '#fde68a'};
    white-space: nowrap;
`;
